import api from "../utils/api";
import { LocationNameModel, LocationModel } from "../common/models/CommonModels";

export const getLocationNames = () => {
    return api.get("api/locations/names").then(response => {
        if (response.status === 200) {
            return response.data as LocationNameModel[];
        }
        return [] as LocationNameModel[]
    }).catch(error => {
        return [] as LocationNameModel[];
    });
}

export const getLocations = () => {
    return api.get("api/locations").then(response => {
        if (response.status === 200) {
            return response.data as LocationModel[];
        }
        return [] as LocationModel[]
    }).catch(error => {
        return [] as LocationModel[];
    });
}


// WEBPACK FOOTER //
// ./src/api/locationsApi.ts